import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { suppliers } from '../data/mock';

export default function DataStreams() {
  return (
    <div className="space-y-6 max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-100">Supplier Data Streams</h1>
          <p className="text-slate-400 text-sm mt-1">Manage Scope 3 data collection and API integrations.</p>
        </div>
        <button className="px-4 py-2 text-sm font-medium text-slate-900 bg-cyan-500 rounded-lg hover:bg-cyan-400 transition-colors shadow-[0_0_15px_rgba(6,182,212,0.3)] flex items-center gap-2">
          <SafeIcon name="Link" className="w-4 h-4" /> Connect New Source
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {['Active API Streams', 'Pending Validations', 'Anomalies Detected'].map((title, i) => (
          <div key={i} className="glass-panel p-4 rounded-xl flex items-center gap-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center bg-slate-800 ${i===0?'text-cyan-400':i===1?'text-amber-400':'text-rose-400'}`}>
              <SafeIcon name={i===0?'Wifi':i===1?'Clock':'AlertTriangle'} className="w-6 h-6" />
            </div>
            <div>
              <p className="text-slate-400 text-xs uppercase tracking-wider">{title}</p>
              <p className="text-2xl font-bold text-slate-100 font-mono mt-1">{i===0?'24':i===1?'7':'0'}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="glass-panel rounded-xl overflow-hidden">
        <div className="p-4 border-b border-slate-800 flex justify-between items-center bg-slate-900/50">
          <h3 className="text-lg font-semibold text-slate-200">Tier 1 Suppliers</h3>
          <div className="flex gap-2">
            <div className="px-3 py-1.5 glass-panel rounded-lg border-slate-700/50 text-sm text-slate-400 flex items-center gap-2">
              <SafeIcon name="Filter" className="w-4 h-4" /> Filter
            </div>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm text-slate-300">
            <thead className="text-xs text-slate-400 uppercase bg-slate-900/80 border-b border-slate-800">
              <tr>
                <th className="px-6 py-4 font-medium">Supplier ID / Name</th>
                <th className="px-6 py-4 font-medium">Category</th>
                <th className="px-6 py-4 font-medium">Emissions (tCO2e)</th>
                <th className="px-6 py-4 font-medium">Risk Level</th>
                <th className="px-6 py-4 font-medium">Data Status</th>
                <th className="px-6 py-4 font-medium text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800/50">
              {suppliers.map((sup) => (
                <tr key={sup.id} className="hover:bg-slate-800/30 transition-colors">
                  <td className="px-6 py-4">
                    <p className="font-medium text-slate-200">{sup.name}</p>
                    <p className="text-xs text-slate-500 font-mono mt-0.5">{sup.id}</p>
                  </td>
                  <td className="px-6 py-4 text-slate-400">{sup.category}</td>
                  <td className="px-6 py-4 font-mono text-slate-300">{sup.emissions.toFixed(1)}</td>
                  <td className="px-6 py-4">
                    <span className={`px-2 py-1 rounded-md text-xs font-medium border ${
                      sup.risk === 'Low' ? 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' : 
                      sup.risk === 'Medium' ? 'bg-amber-500/10 text-amber-400 border-amber-500/20' : 
                      'bg-rose-500/10 text-rose-400 border-rose-500/20'
                    }`}>
                      {sup.risk}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-2">
                      <div className={`w-2 h-2 rounded-full ${sup.status === 'Verified' ? 'bg-emerald-500' : sup.status === 'Pending' ? 'bg-amber-500' : 'bg-rose-500'}`}></div>
                      <span className="text-xs">{sup.status}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-right">
                    <button className="text-slate-400 hover:text-cyan-400 transition-colors p-1">
                      <SafeIcon name="MoreVertical" className="w-5 h-5" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}